import React from 'react';

import { Box, Button, Container, Grid, Typography } from '@material-ui/core';

import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockCta } from '../types/_blocks.types';
import { normaliseUrl } from '../utils/url';

const useStyles = makeBlockStyles(() => ({
  root: {
    //
  },
}));

type Props = BlockBuilder<BlockCta>;

export const CtaBlock: React.FC<Props> = ({ block }) => {
  const { title, content, ctas } = block;
  const classes = useBlockStyles(useStyles, block);
  return (
    <Box className={classes.boxBlock}>
      <Container className={classes.root}>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={4}
        >
          <Grid item xs={12}>
            <Typography variant="h3">{title}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">{content}</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ flexGrow: 1, width: '100%', textAlign: 'center' }}
          >
            {ctas.map((cta, idx) => (
              <Button
                key={`${cta.id}_${idx}`}
                variant="contained"
                color="primary"
                href={normaliseUrl(cta.link)}
              >
                {cta.label}
              </Button>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
